import { render } from "./ModalPdf.vue?vue&type=template&id=c6973052&ts=true"
import script from "./ModalPdf.vue?vue&type=script&lang=ts"
export * from "./ModalPdf.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__